import React, { FC } from 'react'

import css from './Loading.styl'

export const Loading: FC = () => (
  <div className={css.Loading} />
)
